// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"253":"943144a1","256":"2e26d4ae","649":"12cd93fa","870":"a331b593"}[chunkId] + ".chunk.js";
};